

const month: any = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  
  export const getDate = (value: any) => {
    const date = new Date(value);
    const day = date.getDate();
    // let suffix;
  
    // if (day === 1 || day === 21 || day === 31) {
    //   suffix = "st";
    // } else if (day === 2 || day === 22) {
    //   suffix = "nd";
    // } else if (day === 3 || day === 23) {
    //   suffix = "rd";
    // } else {
    //   suffix = "th";
    // }
  
    return `${day}`;
  };
  export const getMonth = (value: any) => {
    const date = new Date(value);
    return `${month[date.getMonth()]}`;
  };
  export const getYear = (value: any) => {
    const date = new Date(value);
    return `${date.getFullYear()}`;
  };
  
  export const maskAddress = (value: any) => {
    if (!value) return "";
    const str = value;
    const first7 = str.slice(0, 7);
    const last5 = str.slice(-5);
    const maskedMiddle = "...";
    return `${first7}${maskedMiddle}${last5}`;
  };
  export function capitalizeFirstLetter(str: any) {
    if (str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    } else {
      return "";
    }
  }
  
  export const UTCconvert = (date: any) => {
    return date.toISOString();
  };
  // 
  export const debounce = (func: Function, expTime: number) => {
    let timer: ReturnType<typeof setTimeout> | null = null;
  // eslint-disable-next-line
    return function (this: any, ...args: any[]) {
      // eslint-disable-next-line
      const context: any = this;
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => {
        timer = null;
        func.apply(context, args);
      }, expTime);
    };
  };

  interface DebouncedFunction<T extends (...args: any[]) => any> {
    (...args: Parameters<T>): void;
    cancel(): void;
  }
  
  export function debouncenew<T extends (...args: any[]) => any>(
    func: T,
    wait: number
  ): DebouncedFunction<T> {
    let timeout: ReturnType<typeof setTimeout> | null = null;
  
    const debounced = function (this: ThisParameterType<T>, ...args: Parameters<T>) {
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        func.apply(this, args);
        timeout = null;
      }, wait);
    } as DebouncedFunction<T>;
  
    debounced.cancel = () => {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
    };
  
    return debounced;
  }
  
  export function capitalizeAndReplaceUnderscore(input: string): string {
    return input?.replace(/_/g, " ")?.replace(/\b\w/g, (c) => c?.toUpperCase());
  }
  
  export const priceFormatter = (number: any) => {
    if (number) {
      if (typeof number !== "number" && typeof number !== "string") {
        throw new Error(
          "Input must be a number or a string representing a number."
        );
      }
      const stringNumber = number.toString();
      const match = stringNumber.match(/^-?\d+(\.\d{0,5})?/);
  
      if (!match) {
        throw new Error("Invalid number format.");
      }
  
      let formattedNumber = match[0];
      const decimalIndex = formattedNumber.indexOf(".");
  
      if (decimalIndex !== -1) {
        const decimalPlaces = formattedNumber.length - decimalIndex - 1;
  
        if (decimalPlaces === 1) {
          formattedNumber += "000";
        } else if (decimalPlaces === 2) {
          formattedNumber += "00";
        } else if (decimalPlaces === 3) {
          formattedNumber += "0";
        } else if (decimalPlaces > 4) {
          formattedNumber = formattedNumber.slice(0, decimalIndex + 5);
        }
      } else {
        formattedNumber += ".0000";
      }
  
      return formattedNumber;
    } else {
      return "0";
    }
  };
  
  export const formEnterSubmit = (e: any, form: any) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      form();
    }
  };